export default __webpack_public_path__ + "static/media/pic_payment_error.c3a3ecf1.svg";